<template>
	<div class="store-summary-wrapper">
		<div class="icon-container">
			<img v-if="isLocalStore" src="/assets/images/stores/map-pin-my-store.png" alt="map pin" />
			<img v-else src="/assets/images/stores/map-pin.png" alt="map pin" />
		</div>
		<div class="content-container">
			<div class="row-space-between" style="margin-bottom:5px;">
				<h2>{{ store.cityAlias }}, {{ store.state }}</h2>
				<span class="bold right" v-if="store.distanceMi">
					{{ store.distanceMi }} miles
				</span>
			</div>
			<div class="row-space-between">
				<span class="grey">
					{{ store.address1 }}<br />
					{{ store.city }} {{ store.state }} {{ store.zip }}
				</span>
				<span class="bold red right store-hours" v-if="store.comingSoon">
					This store is coming soon!
				</span>
				<span class="bold red right store-hours" v-else-if="store.currentHoursJson.status">
					{{ store.currentHoursJson.status }}
				</span>
			</div>
			<div class="store-btns row-space-between">
				<ui-button
					v-if="!store.comingSoon"
					:href="!isLocalStore ? `/stores/set/${store.storeNum}` : null"
					:color="isLocalStore ? 'soft-blue-green' : 'soft-blue-outline'"
					size="sm"
					:icon="isLocalStore ? 'check' : ''"
				>
					{{ isLocalStore ? 'This is My Store' : 'Make This My Store' }}
				</ui-button>
				<ui-button
					color="soft-blue-outline"
					size="sm"
					:href="`/stores/${store.urlAlias}`"
				>
					View Store Page
				</ui-button>
			</div>
		</div>
	</div>
</template>

<script>
import { get } from 'vuex-pathify';
export default {
	name: 'StoreSummary',
	props: {
		store: {
			type: Object,
			required: true
		}
	},
	computed: {
		localStore: get('localStore'),
		isLocalStore() {
			return this.localStore && this.store.id === this.localStore.id;
		},
	},
};
</script>

<style lang='less' scoped>
@import '../../../less/_mixins.less';
.store-summary-wrapper {
	margin: 20px 0 20px 0;
	border-bottom: 2px solid #E5E7F1;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	h2 {
		font-size: 20px;
		font-weight: 500;
		margin:0;
		padding:0;
	}
	span {
		font-size: 16px;
		line-height: 1.25em;
		&.red {
			color: #B12F31;
		}
		&.grey {
			color: #666666;
		}
		&.bold {
			font-weight: bold;
		}
		&.right {
			text-align: right;
		}
		&.store-hours {
			max-width: 100px;
		}
	}
	.store-btns {
		margin: 12px 0;
		.ui-btn {
			display: flex;
			align-items: center;
			justify-content: center;
			&:first-of-type {
				margin-right: 10px;
			}
			&:last-of-type {
				margin-left: 10px;
			}
		}
	}
	.icon-container img {
		height: 26px;
		width: 26px;
	}
	.content-container {
		flex: 1;
		padding-left: 5px;
	}
}
.row-space-between {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
@media screen and (max-width: @mobile-small) {
	.store-summary-wrapper {
		h2 {
			font-size: 14px;
		}
		span {
			font-size: 12px;
			&.store-hours {
				max-width: 70px;
			}
		}
	}
}
</style>